import { render, staticRenderFns } from "./OrderTitle.vue?vue&type=template&id=c8644d28&scoped=true&"
import script from "./OrderTitle.vue?vue&type=script&lang=js&"
export * from "./OrderTitle.vue?vue&type=script&lang=js&"
import style0 from "./OrderTitle.vue?vue&type=style&index=0&id=c8644d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8644d28",
  null
  
)

export default component.exports